import { css } from 'lit';
import { css } from 'lit';

export default css`
	.panel {
		position: absolute;
		right: 0;
		width: 550px;
		z-index: 99999;

		display: flex;
		flex-direction: column;

		box-shadow: 0 6px 10px 4px rgba(0, 0, 0, 0.3);

		color: black;
	}
	.panel-title {
		color: white;
		font-weight: bold;
		display: flex;
		align-items: center;
		gap: var(--ggutter);
		background: rgb(var(--brand-primary));
		padding: var(--ggutter);
		height: var(--header-height);
		box-sizing: border-box;
		border-left: 1px solid white;

		app-btn {
			margin-left: auto;
			color: white;
			border-color: white;
		}
	}

	.panel-content {
		display: flex;
		flex-direction: column;
		background: white;
		max-height: 60vh;
		overflow-y: scroll;
	}

	.alert {
		border-bottom: 1px solid rgb(var(--brand-grey));
		padding: var(--ggutter);

		h3 {
			font-weight: bold;
		}
	}

	.alert.danger:hover {
		background: rgba(var(--brand-status-danger), 0.15);
	}

	.alert.danger {
		background: rgba(var(--brand-status-danger), 0.08);
	}

	.alert.caution {
		background: rgba(var(--brand-status-caution), 0.08);
	}

	.alert.caution:hover {
		background: rgba(var(--brand-status-caution), 0.15);
	}

	.alerts-container {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.alerts-container > app-icon.active {
		color: rgb(171, 74, 85);
		background: rgba(171, 74, 85, 0.3);
		box-shadow: 0 0 0 5px rgb(171, 74, 85);
	}

	.alerts-container > app-icon.open,
	.alerts-container > app-icon:hover {
		background-color: rgba(var(--brand-primary-darkest), 0.5);
	}

	.alerts-container > app-icon {
		padding: calc(var(--ggutter) / 2);
		border-radius: 50%;
		border: none;
		position: relative;
		cursor: pointer;
	}

	@keyframes border-pulse {
		0% {
			box-shadow: 0 0 0 5px rgb(171, 74, 85);
		}
		50% {
			box-shadow: 0 0 0 10px rgb(171, 74, 85);
		}
		100% {
			box-shadow: 0 0 0 5px rgb(171, 74, 85);
		}
	}
	app-icon.alert-icon.danger {
		color: rgb(var(--brand-status-danger));
	}
	app-icon.alert-icon.caution {
		color: rgb(var(--brand-status-caution));
	}

	app-btn {
		padding: calc(var(--ggutter) / 6) calc(var(--ggutter) / 2);
		color: rgb(var(--brand-focus));
		font-weight: 600;
		border: 2px solid rgb(var(--brand-focus));
		border-radius: 3px;
	}
`;
